import { useState } from "react";
import SvgIcon from "../SvgIcon";

export const RadioMultipleVerticalGroup = ({
  label,
  required = false,
  name,
  radios = [],
  handleStateChange,
  currentValue,
}) => {
  const [formState, setFormState] = useState(currentValue);

  const handleSelectionChange = (value) => {
    let data = JSON.parse(JSON.stringify(formState));
    if (!formState.includes(value)) {
      data.length === 1 && data[0].length === 0
        ? (data = [value])
        : data.push(value);
    } else {
      if (formState.length > 0) {
        const filetered = data.filter((val) => val != value);
        data = filetered.length > 0 ? filetered : [""];
      }
    }
    setFormState(data);
    handleStateChange(data);
  };

  return (
    <div className="w-[340px]">
      {label && (
        <label className={`label${required ? " req" : ""}`} htmlFor={name}>
          {label}
        </label>
      )}
      <div className="list-wrapper">
        {radios.map((radio) => {
          const value = radio.value ? radio.value : radio;
          const label = radio.label ? radio.label : radio;
          const checked = formState.includes(value);
          return (
            <div className="radio-group-widgets">
              <SvgIcon
                noFilterOnLight={checked ? true : false}
                src={
                  checked
                    ? "/img/new-icons/checked-square.svg"
                    : "/img/new-icons/unchecked-square.svg"
                }
                onClickFn={() => handleSelectionChange(value)}
              />

              <p className="p1">{label}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};
